import { apiRequest } from '@utils/request';
import { VanityUrlMetadata } from 'types/vanity';

export async function getVanityUrlMetadata(vanityUrlSlug: string): Promise<VanityUrlMetadata> {
	const response = await apiRequest.get(`/vanity/${vanityUrlSlug}`, {
		suppressToast: () => true
	});
	return response.data;
}
